import { isMobileScreen } from '@apply/ui';
import { PreviousButton } from './components/PreviousButton';
import { CustomPaymentStep } from '../../../../constants/CustomPaymentStep';
import { SubmitPaymentButton } from './components/SubmitPaymentButton';

interface CheckoutButtonPanelProps {
    customPaymentId: string;
    paymentAgreementAccepted: boolean;
    notSupportedCardType: boolean;
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
    errorMessage: string | undefined;
    set_errorMessage: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const CheckoutButtonPanel: React.FC<CheckoutButtonPanelProps> = ({
    customPaymentId,
    paymentAgreementAccepted,
    notSupportedCardType,
    set_paymentStep,
    errorMessage,
    set_errorMessage,
}) => {
    const mobileScreen = isMobileScreen();

    return (
        <>
            <div className={`customPayment-buttonPanel ${mobileScreen ? 'mobile' : ''}`}>
                <PreviousButton set_paymentStep={set_paymentStep} />
                <SubmitPaymentButton
                    customPaymentId={customPaymentId}
                    paymentAgreementAccepted={paymentAgreementAccepted}
                    notSupportedCardType={notSupportedCardType}
                    set_paymentStep={set_paymentStep}
                    errorMessage={errorMessage}
                    set_errorMessage={set_errorMessage}
                />
            </div>
        </>
    );
};
